<script setup lang="ts">
  import { RouterView } from 'vue-router'
  import { onMounted } from 'vue'
  import { Motion } from 'motion-v'
  import { ConfigProvider } from 'radix-vue'
  import { useAppStore } from '@/stores/app'
  import { useLocale } from '@/composables/useLocale'
  import { buildFadeTransition, routeShellPreset } from '@/utils/motion'
  import Toaster from './components/ui/toast/Toaster.vue'

  const appStore = useAppStore()
  onMounted(() => {
    appStore.initTheme()
  })
  const { dir } = useLocale()
</script>

<template>
  <ConfigProvider :dir="dir">
    <div :dir="dir" class="relative h-screen overflow-hidden">
      <router-view v-slot="{ Component, route }">
        <Motion
          :key="route.matched[0]?.path ?? route.path"
          :initial="routeShellPreset.initial"
          :animate="routeShellPreset.animate"
          :transition="buildFadeTransition()"
          class="h-full"
        >
          <component :is="Component" />
        </Motion>
      </router-view>
      <Toaster />
    </div>
  </ConfigProvider>
</template>
